import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
export var loadingSpinner = /*#__PURE__*/css(["margin-top:", ";"], pxToRem(-2));